import React from 'react';
import styled from 'styled-components';

import { Typography } from 'src/typography';

type InstoreReceiptItemDesktopProps = {
  productName: string;
  brandName?: string | null;
  option?: string | null;
  quantity: number;
  formattedPrice: string;
};

export function InstoreReceiptItemDesktop({
  productName,
  brandName,
  option,
  quantity,
  formattedPrice,
}: InstoreReceiptItemDesktopProps): JSX.Element {
  return (
    <Row data-testid='instore-receipt-item'>
      <ProductInfo>
        <ProductName tag='p' size='large' weight='bold'>
          {productName}
        </ProductName>
        {brandName && (
          <Typography.Body tag='p' size='xsmall'>
            {brandName}
          </Typography.Body>
        )}
      </ProductInfo>
      <Meta>
        <Weight tag='div' size='small'>
          <span>Weight:</span>&nbsp;{option ?? 'N/A'}
        </Weight>
        <Quantity tag='div' size='small'>
          <span>Qty:</span>&nbsp;{quantity}
        </Quantity>
      </Meta>
      <Price tag='p' size='small' weight='bold' aria-label={`Price: ${formattedPrice}`}>
        {formattedPrice}
      </Price>
    </Row>
  );
}

const Row = styled.li`
  width: 100%;
  padding: 20px 0;
  color: ${({ theme }) => theme.colors.grey[30]};
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.blueGrey[90]};

  &:last-of-type {
    border-bottom: 0;
  }
`;

const ProductInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
  width: 100%;
  max-width: 350px;
`;

const ProductName = styled(Typography.Body)`
  line-height: 120%;
  margin-bottom: 3px;
  color: var(--dcm-color-text-primary, ${({ theme }) => theme.colors.primaryBlack});
`;

const Meta = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

const ItemMeta = styled(Typography.Body)`
  text-align: left;
  display: flex;
  align-items: center;
  margin-left: 20px;
  white-space: nowrap;

  span {
    font-weight: bold;
    text-transform: capitalize;
  }
`;

const Weight = styled(ItemMeta)`
  width: 100px;
`;

const Quantity = styled(ItemMeta)`
  width: 50px;
`;

const Price = styled(Typography.Body)`
  display: flex;
  flex-grow: 1;
  flex-shrink: 0;
  align-items: center;
  text-align: right;
  justify-content: flex-end;
  margin-left: 20px;
  white-space: nowrap;
`;
